export const itemBankSetupI18n = {
  itemBankSetup: {
    actions: {
      cancel: 'Cancel',
      save: 'Save',
      edit: 'Edit',
      retry: 'Retry',
      refresh: 'Refresh',
      close: 'Close',
    },
    errors: {
      loadTitle: 'Could not load this list',
      deniedTitle: 'You do not have access to the item bank',
    },
    discardChanges: {
      title: 'Discard unsaved changes?',
      message: 'You have unsaved changes. Closing now will discard them.',
      keepEditing: 'Keep editing',
      discard: 'Discard',
    },
    smes: {
      rosterImport: {
        button: 'Import roster',
        title: 'Import SME roster',
        intro: 'Add your SME panel from a spreadsheet. Existing SMEs are left as they are. '
          + 'Everything can be edited afterwards.',
        downloadTemplate: 'Download template',
        chooseFile: 'Roster spreadsheet (.csv)',
        createAssignments: 'Also create writing assignments',
        noWaves: 'This program has no form waves yet, so quotas cannot be worked out. '
          + 'Add a form wave in the Blueprint tab first.',
        formWave: 'Form wave',
        formWaveWeightBy: 'Weight by form wave',
        quotaMode: 'Quotas',
        quotaModeItemsPerWriter: 'Items per writer',
        quotaModeDerived: 'Derive from wave targets',
        itemsPerWriter: 'Items per writer',
        roundLabel: 'Round label',
        windowOpens: 'Window opens',
        standardDeadline: 'Standard deadline',
        fastDeadline: 'Fast deadline (optional)',
        sprintDeadline: 'Sprint deadline (optional)',
        checkFile: 'Check file',
        import: 'Import',
        close: 'Close',
        previewTitle: 'Preview',
        previewNoChanges: 'Nothing has been imported yet.',
        columns: {
          row: 'Row',
          name: 'Name',
          email: 'Email',
          username: 'Username',
          action: 'Result',
          total: 'Total',
        },
        actionCreate: 'New',
        actionExisting: 'Already on file',
        actionError: 'Error',
        assignmentExists: 'An assignment already exists for this round and will not be changed.',
        counts: '{create} new, {existing} already on file, {errors} with errors.',
        totalsTitle: 'Quota against need',
        totalsRowLabel: 'Quota / needed',
        quotaOfNeeded: '{quota} / {needed}',
        quotaNote: 'Quotas are worked out from the wave\'s targets at an 80% acceptance rate and can be '
          + 'changed per SME in the Assignments tab.',
        quotaNoteItemsPerWriter: 'Each writer gets {count} items, split across the domains in proportion to the '
          + 'wave\'s targets. Quotas can be changed per SME in the Assignments tab.',
        fixErrors: 'Fix the rows marked Error in the spreadsheet, then check the file again.',
        staleCheck: 'The file or options changed after the last check. Check the file again before importing.',
        tooLarge: 'The file is too large to upload. Remove unused rows or columns and try again.',
        success: 'Roster imported: {created} new, {existing} already on file.',
        successAssignments: 'Writing assignments created: {count}.',
        successPassword: 'New SMEs set their own password with the "Forgot Password?" link on the login page.',
        sendInvites: 'Email each new SME an invite to set their password',
        successInvites: 'Invites emailed: {count}.',
      },
      addButton: 'Add SME',
      addTitle: 'Add SME',
      editTitle: 'Edit SME profile',
      accountLabel: 'Account',
      newAccount: 'New SME account',
      existingAccount: 'Existing staff user',
      createsInactive: 'New SME profiles are created inactive. Activate the profile once the contract '
        + 'and training dates are on record.',
      clearingDateWarning: 'This SME is currently active. Clearing the contract or training date will '
        + 'revoke access immediately when you save.',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      username: 'Username',
      phone: 'Phone',
      password: 'Password',
      passwordHint: 'At least 10 characters. Shown only once, here.',
      staffUserSearch: 'Search staff users',
      staffUserSearchPlaceholder: 'Search by name, username or email',
      displayName: 'Display name',
      credentials: 'Credentials',
      contractRoute: 'Contract route',
      stateCode: 'State',
      contractExecutedAt: 'Contract executed date',
      coiDisclosedAt: 'Conflict of interest disclosed date',
      trainingCompletedAt: 'Training completed date',
      practiceSetting: 'Practice setting',
      yearsExperience: 'Years of experience',
      canWrite: 'Writer',
      canReview: 'Reviewer',
      notes: 'Notes',
      empty: 'No SME profiles exist yet.',
      activationRule: 'Activation requires both the contract executed date and the training completed '
        + 'date to be on or before today.',
      activate: 'Activate',
      deactivate: 'Deactivate',
      deactivateTitle: 'Deactivate SME',
      deactivateMessage: 'Deactivating {name} ends their session immediately. This is a status change, '
        + 'not a deletion — the profile and their item history are kept.',
      deactivateConfirm: 'Deactivate',
      activateOnboardingIncomplete: 'This SME cannot be activated yet. Missing: {fields}.',
      activateNoRole: 'This SME needs the writer or reviewer role before they can be activated.',
      active: 'Active',
      inactive: 'Inactive',
      onboardingComplete: 'Complete',
      onboardingMissing: 'Missing: {fields}',
      writer: 'Writer',
      reviewer: 'Reviewer',
      invite: {
        send: 'Send invite',
        resend: 'Resend invite',
        sent: 'Invite emailed to {email}.',
        copy: 'Copy username',
        copyFailed: 'Could not copy. Select the username and copy it instead.',
        staffAccount: 'Staff sign-in',
        status: {
          not_invited: 'Not invited',
          invited: 'Invited',
          expired: 'Invite expired',
          password_set: 'Password set',
        },
      },
      columns: {
        displayName: 'Display name',
        username: 'Username',
        invite: 'Invite',
        accountType: 'Account type',
        roles: 'Roles',
        onboarding: 'Onboarding',
        active: 'Active',
        lastActivity: 'Last activity',
        contractRoute: 'Contract route',
      },
    },
    assignments: {
      updateRoundButton: 'Update round',
      addButton: 'Add assignment',
      addTitle: 'Add writing assignment',
      editTitle: 'Edit writing assignment',
      filterBySme: 'Filter by SME',
      empty: 'No writing assignments exist yet for this program.',
      sme: 'SME',
      roundLabel: 'Round label',
      windowOpensAt: 'Window opens',
      targetDeadline: 'Standard (target) deadline',
      sprintDeadline: 'Sprint deadline',
      fastDeadline: 'Fast deadline',
      notes: 'Notes',
      quotasLabel: 'Per-domain quotas',
      quotasHint: 'Leave a domain blank or 0 for no quota. Only positive quotas are saved.',
      needAtLeastOneQuota: 'Enter a quota for at least one domain.',
      sprintAfterFast: 'The sprint deadline must be on or before the fast deadline.',
      fastAfterTarget: 'The fast deadline must be on or before the standard deadline.',
      sprintAfterTarget: 'The sprint deadline must be on or before the standard deadline.',
      windowAfterTarget: 'The standard deadline must be after the date the window opens.',
      columns: {
        sme: 'SME',
        round: 'Round',
        windowOpens: 'Window opens',
        standardDeadline: 'Standard deadline',
        sprintDeadline: 'Sprint deadline',
        fastDeadline: 'Fast deadline',
        progress: 'Progress by domain',
        totals: 'Written / quota',
        quotaCompletedAt: 'Quota completed',
        tierAchieved: 'Tier achieved',
      },
      updateRound: {
        title: 'Update round',
        intro: 'Change the dates, the quotas, or both for every writer in a round at once. Nothing is saved '
          + 'until you check the changes and apply them. Edit a single assignment for one writer\'s exceptions.',
        round: 'Round',
        noRounds: 'This program has no writing assignments yet.',
        datesTitle: 'Dates',
        datesHint: 'Leave a date blank to keep each writer\'s own.',
        windowOpens: 'Window opens',
        standardDeadline: 'Standard deadline',
        fastDeadline: 'Fast deadline',
        sprintDeadline: 'Sprint deadline',
        clearFast: 'Remove the fast deadline',
        clearSprint: 'Remove the sprint deadline',
        quotasTitle: 'Quotas',
        setQuotas: 'Set quotas for the whole round',
        quotasHint: 'Each writer\'s total is split across the active domains in proportion to the wave\'s '
          + 'targets, replacing their current quotas.',
        itemsPerWriter: 'Items per writer',
        formWave: 'Weight by form wave',
        noWaves: 'This program has no form waves yet, so quotas cannot be weighted. Add a form wave in the Blueprint tab first.',
        check: 'Check changes',
        apply: 'Apply to round',
        previewTitle: 'Preview',
        previewNoChanges: 'Nothing has been saved yet.',
        currentTitle: 'Writers in this round',
        counts: '{count} writers in this round, {errors} with problems.',
        staleCheck: 'The options changed after the last check. Check the changes again before applying.',
        fixErrors: 'Fix the dates marked below, then check the changes again. Nothing is saved while any writer has a problem.',
        changedDate: 'Changed',
        columns: {
          sme: 'SME',
          windowOpens: 'Window opens',
          standardDeadline: 'Standard deadline',
          fastDeadline: 'Fast deadline',
          sprintDeadline: 'Sprint deadline',
          quota: 'Quota',
          written: 'Written',
          total: 'Total',
        },
        writtenBelowQuota: '{domain}: already written {written}, new quota {quota}.',
        lowerQuotaNote: 'A quota below what is already written is saved as it is, and nothing is removed. A writer '
          + 'who has then met every quota is marked complete today.',
        totalsRowLabel: 'Quota / needed',
        targetRowLabel: 'Wave target',
        quotaOfNeeded: '{quota} / {needed}',
        quotaNote: 'Needed is the wave\'s growth in target at an 80% acceptance rate. Quotas can be changed per SME '
          + 'with Edit.',
        success: 'Round updated: {count} assignments changed.',
      },
    },
    blueprint: {
      gapWarningTitle: 'Blueprint gap: these domains have no mapped learning outcome',
      gapWarningDomains: '{domains}',
      gapWarningNote: 'Items cannot be written for these domains until a mapping is confirmed by the '
        + 'compliance manager and the psychometric vendor. Never guess or auto-create a mapping.',
      alignmentErrorTitle: 'Could not load item counts',
      briefTitle: 'Item writing brief',
      brief: 'Item writing brief',
      briefEmpty: 'No item writing brief set yet.',
      briefHint: 'Shown to SMEs on the item form and review queue while they write and review. Cover the '
        + 'audience, the item style the panel wants and any topics they should draw on.',
      editBriefTitle: 'Edit item writing brief',
      domainsTitle: 'Domains',
      addDomain: 'Add domain',
      addDomainTitle: 'Add domain',
      editDomainTitle: 'Edit domain',
      domainCode: 'Code',
      domainName: 'Name',
      sortOrder: 'Sort order',
      active: 'Active',
      inactive: 'Inactive',
      mappedOutcomes: 'Mapped outcomes',
      mappedDomains: 'Mapped domains',
      noDomains: 'No domains exist yet for this program.',
      editMapping: 'Edit mapping',
      outcomesTitle: 'Learning outcomes',
      addOutcome: 'Add outcome',
      addOutcomeTitle: 'Add learning outcome',
      editOutcomeTitle: 'Edit learning outcome',
      outcomeCode: 'Code',
      outcomeText: 'Text',
      outcomeSearch: 'Search by code or text',
      outcomeDomainFilter: 'Domain',
      allDomains: 'All domains',
      unmappedDomain: 'Unmapped',
      noOutcomesMatch: 'No learning outcomes match the search.',
      outcomeEditWarning: 'Changing this wording changes what existing items are measured against. '
        + 'Items keep their tag.',
      outcomeItemCount: 'Items tagged with this outcome: {count}.',
      noOutcomes: 'No learning outcomes exist yet for this program.',
      noOutcomeMapped: 'No learning outcome mapped',
      outcomeDomain: 'Risk factor',
      outcomeDomainMultiple: 'This outcome is under more than one risk factor. Saving keeps only the one chosen here.',
      outcomeDomainLocked: 'Items are written against this outcome, so it stays under its risk factor. '
        + 'Add a new outcome under the other risk factor instead.',
      mappingTitle: 'Mapped outcomes — {domain}',
      mappingHint: 'An outcome belongs to one risk factor. Ticking an outcome that is under another risk factor moves it '
        + 'here; unticking one leaves it with no risk factor.',
      mappingLockedHint: 'Outcomes with items written against them cannot move or be removed. Add a new outcome '
        + 'under the other risk factor instead.',
      inDomain: 'in {domain}',
      outcomeItems: '{count} items',
      noOutcomesInProgram: 'This program has no learning outcomes yet. Add one before mapping.',
    },
    formWaves: {
      title: 'Form waves',
      addButton: 'Add form wave',
      addTitle: 'Add form wave',
      editTitle: 'Edit form wave',
      empty: 'No form waves exist yet. Waves stage item targets so the first forms — for example '
        + 'the first two — can be finished before the rest.',
      columnOrder: 'Order',
      columnLabel: 'Label',
      columnForms: 'Forms',
      columnTargetDate: 'Target date',
      columnTargetsSet: 'Targets set',
      targetsSetCount: '{set} of {total} domains',
      setTargets: 'Set targets',
      label: 'Label',
      formCount: 'Number of forms',
      formCountRangeHint: 'Must be more than {min} and less than {max}.',
      formCountMinHint: 'Must be more than {min}.',
      targetDate: 'Target date',
      targetsDialogTitle: 'Set targets — {wave}',
      targetsDialogHint: 'Leave a domain blank for no target this wave (shown as "TBC"). Targets are '
        + 'cumulative: each wave\'s target must be at or above the previous wave\'s and at or below the next.',
      targetsPreviousHint: 'Previous ({label}): {value}',
      targetsNextHint: 'Next ({label}): {value}',
      targetInactiveDomain: 'Inactive',
      targetsImplied: 'Targets include earlier waves and the reserve. The per-form figure spreads each '
        + 'target across this wave\'s {forms} forms, allowing a 30% reserve.',
      targetPerForm: '≈ {perForm} per form',
    },
  },
};

export const itemBankSetupI18nEs = {
  itemBankSetup: {
    actions: {
      cancel: 'Cancelar',
      save: 'Guardar',
      edit: 'Editar',
      retry: 'Reintentar',
      refresh: 'Actualizar',
      close: 'Cerrar',
    },
    errors: {
      loadTitle: 'No se pudo cargar esta lista',
      deniedTitle: 'No tienes acceso al banco de ítems',
    },
    discardChanges: {
      title: '¿Descartar los cambios sin guardar?',
      message: 'Hay cambios sin guardar. Si cierras ahora, se descartarán.',
      keepEditing: 'Seguir editando',
      discard: 'Descartar',
    },
    smes: {
      rosterImport: {
        button: 'Importar lista',
        title: 'Importar lista de expertos',
        intro: 'Agrega a tu panel de expertos desde una hoja de cálculo. Los expertos que ya existen no se modifican. '
          + 'Todo se puede editar después.',
        downloadTemplate: 'Descargar plantilla',
        chooseFile: 'Hoja de cálculo de la lista (.csv)',
        createAssignments: 'Crear también asignaciones de redacción',
        noWaves: 'Este programa todavía no tiene oleadas de formularios, así que no se pueden calcular las cuotas. '
          + 'Primero agrega una oleada en la pestaña Tabla de especificaciones.',
        formWave: 'Oleada de formularios',
        formWaveWeightBy: 'Ponderar por oleada de formularios',
        quotaMode: 'Cuotas',
        quotaModeItemsPerWriter: 'Ítems por redactor',
        quotaModeDerived: 'Derivar de los objetivos de la oleada',
        itemsPerWriter: 'Ítems por redactor',
        roundLabel: 'Etiqueta de la ronda',
        windowOpens: 'Apertura de la ventana',
        standardDeadline: 'Fecha límite estándar',
        fastDeadline: 'Fecha límite rápida (opcional)',
        sprintDeadline: 'Fecha límite sprint (opcional)',
        checkFile: 'Revisar archivo',
        import: 'Importar',
        close: 'Cerrar',
        previewTitle: 'Vista previa',
        previewNoChanges: 'Todavía no se ha importado nada.',
        columns: {
          row: 'Fila',
          name: 'Nombre',
          email: 'Correo electrónico',
          username: 'Usuario',
          action: 'Resultado',
          total: 'Total',
        },
        actionCreate: 'Nuevo',
        actionExisting: 'Ya registrado',
        actionError: 'Error',
        assignmentExists: 'Ya existe una asignación para esta ronda y no se modificará.',
        counts: '{create} nuevos, {existing} ya registrados, {errors} con errores.',
        totalsTitle: 'Cuota frente a lo necesario',
        totalsRowLabel: 'Cuota / necesario',
        quotaOfNeeded: '{quota} / {needed}',
        quotaNote: 'Las cuotas se calculan a partir de los objetivos de la oleada con una tasa de aceptación del 80 % '
          + 'y se pueden cambiar por experto en la pestaña Asignaciones.',
        quotaNoteItemsPerWriter: 'Cada redactor recibe {count} ítems, repartidos entre los dominios en proporción a '
          + 'los objetivos de la oleada. Las cuotas se pueden cambiar por experto en la pestaña Asignaciones.',
        fixErrors: 'Corrige en la hoja de cálculo las filas marcadas con Error y vuelve a revisar el archivo.',
        staleCheck: 'El archivo o las opciones cambiaron después de la última revisión. '
          + 'Vuelve a revisar el archivo antes de importar.',
        tooLarge: 'El archivo es demasiado grande para subirlo. Quita filas o columnas que no uses e inténtalo de nuevo.',
        success: 'Lista importada: {created} nuevos, {existing} ya registrados.',
        successAssignments: 'Asignaciones de redacción creadas: {count}.',
        successPassword: 'Los expertos nuevos definen su propia contraseña con el enlace "Forgot Password?" '
          + 'de la página de inicio de sesión.',
        sendInvites: 'Enviar a cada experto nuevo una invitación para definir su contraseña',
        successInvites: 'Invitaciones enviadas: {count}.',
      },
      addButton: 'Agregar experto',
      addTitle: 'Agregar experto en la materia',
      editTitle: 'Editar perfil de experto',
      accountLabel: 'Cuenta',
      newAccount: 'Nueva cuenta de experto',
      existingAccount: 'Usuario del personal existente',
      createsInactive: 'Los nuevos perfiles de experto se crean inactivos. Activa el perfil una vez que las fechas '
        + 'de contrato y capacitación estén registradas.',
      clearingDateWarning: 'Este experto está activo actualmente. Si borras la fecha de contrato o de capacitación, '
        + 'se revocará el acceso de inmediato al guardar.',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      username: 'Nombre de usuario',
      phone: 'Teléfono',
      password: 'Contraseña',
      passwordHint: 'Al menos 10 caracteres. Se muestra solo una vez, aquí.',
      staffUserSearch: 'Buscar usuarios del personal',
      staffUserSearchPlaceholder: 'Buscar por nombre, usuario o correo electrónico',
      displayName: 'Nombre para mostrar',
      credentials: 'Credenciales',
      contractRoute: 'Vía de contratación',
      stateCode: 'Estado',
      contractExecutedAt: 'Fecha de firma del contrato',
      coiDisclosedAt: 'Fecha de divulgación de conflicto de interés',
      trainingCompletedAt: 'Fecha de finalización de capacitación',
      practiceSetting: 'Entorno de práctica',
      yearsExperience: 'Años de experiencia',
      canWrite: 'Redactor',
      canReview: 'Revisor',
      notes: 'Notas',
      empty: 'Todavía no existen perfiles de experto.',
      activationRule: 'La activación requiere que tanto la fecha de firma del contrato como la fecha de finalización '
        + 'de capacitación sean anteriores o iguales a hoy.',
      activate: 'Activar',
      deactivate: 'Desactivar',
      deactivateTitle: 'Desactivar experto',
      deactivateMessage: 'Desactivar a {name} finaliza su sesión de inmediato. Esto es un cambio de estado, '
        + 'no una eliminación: el perfil y su historial de ítems se conservan.',
      deactivateConfirm: 'Desactivar',
      activateOnboardingIncomplete: 'Este experto todavía no puede activarse. Falta: {fields}.',
      activateNoRole: 'Este experto necesita el rol de redactor o revisor antes de poder activarse.',
      active: 'Activo',
      inactive: 'Inactivo',
      onboardingComplete: 'Completa',
      onboardingMissing: 'Falta: {fields}',
      writer: 'Redactor',
      reviewer: 'Revisor',
      invite: {
        send: 'Enviar invitación',
        resend: 'Reenviar invitación',
        sent: 'Invitación enviada a {email}.',
        copy: 'Copiar usuario',
        copyFailed: 'No se pudo copiar. Selecciona el usuario y cópialo.',
        staffAccount: 'Cuenta de personal',
        status: {
          not_invited: 'Sin invitar',
          invited: 'Invitado',
          expired: 'Invitación vencida',
          password_set: 'Contraseña definida',
        },
      },
      columns: {
        displayName: 'Nombre para mostrar',
        username: 'Usuario',
        invite: 'Invitación',
        accountType: 'Tipo de cuenta',
        roles: 'Roles',
        onboarding: 'Incorporación',
        active: 'Activo',
        lastActivity: 'Última actividad',
        contractRoute: 'Vía de contratación',
      },
    },
    assignments: {
      updateRoundButton: 'Actualizar ronda',
      addButton: 'Agregar asignación',
      addTitle: 'Agregar asignación de redacción',
      editTitle: 'Editar asignación de redacción',
      filterBySme: 'Filtrar por experto',
      empty: 'Todavía no existen asignaciones de redacción para este programa.',
      sme: 'Experto',
      roundLabel: 'Etiqueta de ronda',
      windowOpensAt: 'Apertura de la ventana',
      targetDeadline: 'Fecha límite estándar (objetivo)',
      sprintDeadline: 'Fecha límite sprint',
      fastDeadline: 'Fecha límite rápida',
      notes: 'Notas',
      quotasLabel: 'Cuotas por dominio',
      quotasHint: 'Deja un dominio en blanco o en 0 para no asignarle cuota. Solo se guardan las cuotas positivas.',
      needAtLeastOneQuota: 'Ingresa una cuota para al menos un dominio.',
      sprintAfterFast: 'La fecha límite sprint debe ser igual o anterior a la fecha límite rápida.',
      fastAfterTarget: 'La fecha límite rápida debe ser igual o anterior a la fecha límite estándar.',
      sprintAfterTarget: 'La fecha límite sprint debe ser igual o anterior a la fecha límite estándar.',
      windowAfterTarget: 'La fecha límite estándar debe ser posterior a la fecha de apertura de la ventana.',
      columns: {
        sme: 'Experto',
        round: 'Ronda',
        windowOpens: 'Apertura de la ventana',
        standardDeadline: 'Fecha límite estándar',
        sprintDeadline: 'Fecha límite sprint',
        fastDeadline: 'Fecha límite rápida',
        progress: 'Progreso por dominio',
        totals: 'Redactados / cuota',
        quotaCompletedAt: 'Cuota completada',
        tierAchieved: 'Nivel alcanzado',
      },
      updateRound: {
        title: 'Actualizar ronda',
        intro: 'Cambia las fechas, las cuotas o ambas para todos los redactores de una ronda a la vez. No se guarda '
          + 'nada hasta que revises los cambios y los apliques. Edita una asignación individual para las excepciones '
          + 'de un redactor.',
        round: 'Ronda',
        noRounds: 'Este programa todavía no tiene asignaciones de redacción.',
        datesTitle: 'Fechas',
        datesHint: 'Deja una fecha en blanco para conservar la de cada redactor.',
        windowOpens: 'Apertura de la ventana',
        standardDeadline: 'Fecha límite estándar',
        fastDeadline: 'Fecha límite rápida',
        sprintDeadline: 'Fecha límite sprint',
        clearFast: 'Quitar la fecha límite rápida',
        clearSprint: 'Quitar la fecha límite sprint',
        quotasTitle: 'Cuotas',
        setQuotas: 'Definir las cuotas de toda la ronda',
        quotasHint: 'El total de cada redactor se reparte entre los dominios activos en proporción a los objetivos '
          + 'de la oleada y reemplaza sus cuotas actuales.',
        itemsPerWriter: 'Ítems por redactor',
        formWave: 'Ponderar por oleada de formularios',
        noWaves: 'Este programa todavía no tiene oleadas de formularios, así que no se pueden ponderar las cuotas. '
          + 'Primero agrega una oleada en la pestaña Tabla de especificaciones.',
        check: 'Revisar cambios',
        apply: 'Aplicar a la ronda',
        previewTitle: 'Vista previa',
        previewNoChanges: 'Todavía no se ha guardado nada.',
        currentTitle: 'Redactores de esta ronda',
        counts: '{count} redactores en esta ronda, {errors} con problemas.',
        staleCheck: 'Las opciones cambiaron después de la última revisión. Vuelve a revisar los cambios antes de aplicarlos.',
        fixErrors: 'Corrige las fechas marcadas abajo y vuelve a revisar los cambios. No se guarda nada mientras algún '
          + 'redactor tenga un problema.',
        changedDate: 'Cambiada',
        columns: {
          sme: 'Experto',
          windowOpens: 'Apertura de la ventana',
          standardDeadline: 'Fecha límite estándar',
          fastDeadline: 'Fecha límite rápida',
          sprintDeadline: 'Fecha límite sprint',
          quota: 'Cuota',
          written: 'Redactados',
          total: 'Total',
        },
        writtenBelowQuota: '{domain}: ya redactó {written}, la nueva cuota es {quota}.',
        lowerQuotaNote: 'Una cuota inferior a lo ya redactado se guarda tal cual y no se quita nada. Un redactor que '
          + 'ya haya cumplido todas las cuotas se marca como completo hoy.',
        totalsRowLabel: 'Cuota / necesario',
        targetRowLabel: 'Objetivo de la oleada',
        quotaOfNeeded: '{quota} / {needed}',
        quotaNote: 'Necesario es el crecimiento del objetivo de la oleada con una tasa de aceptación del 80 %. Las '
          + 'cuotas se pueden cambiar por experto con Editar.',
        success: 'Ronda actualizada: {count} asignaciones modificadas.',
      },
    },
    blueprint: {
      gapWarningTitle: 'Brecha en la tabla de especificaciones: estos dominios no tienen un resultado de aprendizaje asignado',
      gapWarningDomains: '{domains}',
      gapWarningNote: 'No se pueden redactar ítems para estos dominios hasta que el gerente de cumplimiento y el proveedor '
        + 'psicométrico confirmen una asignación. Nunca adivines ni crees una asignación automáticamente.',
      alignmentErrorTitle: 'No se pudieron cargar los conteos de ítems',
      briefTitle: 'Guía para la redacción de ítems',
      brief: 'Guía para la redacción de ítems',
      briefEmpty: 'Todavía no se ha establecido una guía de redacción.',
      briefHint: 'Se muestra a los expertos en el formulario de ítems y en la cola de revisión mientras '
        + 'redactan y revisan. Cubre el público, el estilo de ítem que busca el panel y los temas en los que deben basarse.',
      editBriefTitle: 'Editar guía para la redacción de ítems',
      domainsTitle: 'Dominios',
      addDomain: 'Agregar dominio',
      addDomainTitle: 'Agregar dominio',
      editDomainTitle: 'Editar dominio',
      domainCode: 'Código',
      domainName: 'Nombre',
      sortOrder: 'Orden',
      active: 'Activo',
      inactive: 'Inactivo',
      mappedOutcomes: 'Resultados asignados',
      mappedDomains: 'Dominios asignados',
      noDomains: 'Todavía no existen dominios para este programa.',
      editMapping: 'Editar asignación',
      outcomesTitle: 'Resultados de aprendizaje',
      addOutcome: 'Agregar resultado',
      addOutcomeTitle: 'Agregar resultado de aprendizaje',
      editOutcomeTitle: 'Editar resultado de aprendizaje',
      outcomeCode: 'Código',
      outcomeText: 'Texto',
      outcomeSearch: 'Buscar por código o texto',
      outcomeDomainFilter: 'Dominio',
      allDomains: 'Todos los dominios',
      unmappedDomain: 'Sin asignar',
      noOutcomesMatch: 'Ningún resultado de aprendizaje coincide con la búsqueda.',
      outcomeEditWarning: 'Cambiar esta redacción cambia con qué se miden los ítems existentes. '
        + 'Los ítems conservan su etiqueta.',
      outcomeItemCount: 'Ítems etiquetados con este resultado: {count}.',
      noOutcomes: 'Todavía no existen resultados de aprendizaje para este programa.',
      noOutcomeMapped: 'Ningún resultado de aprendizaje asignado',
      outcomeDomain: 'Factor de riesgo',
      outcomeDomainMultiple: 'Este resultado está en más de un factor de riesgo. Al guardar solo se conserva el elegido aquí.',
      outcomeDomainLocked: 'Hay ítems redactados para este resultado, así que permanece en su factor de riesgo. '
        + 'Agrega en su lugar un resultado nuevo en el otro factor de riesgo.',
      mappingTitle: 'Resultados asignados — {domain}',
      mappingHint: 'Un resultado pertenece a un solo factor de riesgo. Marcar un resultado que está en otro factor de '
        + 'riesgo lo mueve aquí; desmarcarlo lo deja sin factor de riesgo.',
      mappingLockedHint: 'Los resultados con ítems redactados no se pueden mover ni quitar. Agrega en su lugar un '
        + 'resultado nuevo en el otro factor de riesgo.',
      inDomain: 'en {domain}',
      outcomeItems: '{count} ítems',
      noOutcomesInProgram: 'Este programa todavía no tiene resultados de aprendizaje. Agrega uno antes de asignar.',
    },
    formWaves: {
      title: 'Oleadas de formularios',
      addButton: 'Agregar oleada de formularios',
      addTitle: 'Agregar oleada de formularios',
      editTitle: 'Editar oleada de formularios',
      empty: 'Todavía no existen oleadas de formularios. Las oleadas escalonan los objetivos de ítems para que los '
        + 'primeros formularios, por ejemplo los dos primeros, puedan terminarse antes que el resto.',
      columnOrder: 'Orden',
      columnLabel: 'Etiqueta',
      columnForms: 'Formularios',
      columnTargetDate: 'Fecha objetivo',
      columnTargetsSet: 'Objetivos definidos',
      targetsSetCount: '{set} de {total} dominios',
      setTargets: 'Definir objetivos',
      label: 'Etiqueta',
      formCount: 'Número de formularios',
      formCountRangeHint: 'Debe ser mayor que {min} y menor que {max}.',
      formCountMinHint: 'Debe ser mayor que {min}.',
      targetDate: 'Fecha objetivo',
      targetsDialogTitle: 'Definir objetivos — {wave}',
      targetsDialogHint: 'Deja un dominio en blanco para no asignarle objetivo en esta oleada (se muestra como '
        + '"Por definir"). Los objetivos son acumulativos: el objetivo de cada oleada debe ser igual o mayor que el '
        + 'de la oleada anterior e igual o menor que el de la siguiente.',
      targetsPreviousHint: 'Anterior ({label}): {value}',
      targetsNextHint: 'Siguiente ({label}): {value}',
      targetInactiveDomain: 'Inactivo',
      targetsImplied: 'Los objetivos incluyen las oleadas anteriores y la reserva. La cifra por formulario reparte '
        + 'cada objetivo entre los {forms} formularios de esta oleada, con una reserva del 30 %.',
      targetPerForm: '≈ {perForm} por formulario',
    },
  },
};
